import { useCallback, useEffect, useState } from "react";
import {
  CONTESTACION_AVISOS_EVENT,
  fetchContestacionAvisos,
  postContestacionAviso,
} from "../../api/Estimates/contestacionAvisoApi";

export function useContestacionAvisos(enabled = true) {
  const [items, setItems] = useState([]);

  const reload = useCallback(async () => {
    if (!enabled) {
      setItems([]);
      return;
    }
    try {
      const data = await fetchContestacionAvisos();
      setItems(Array.isArray(data?.items) ? data.items : []);
    } catch (error) {
      console.error("Avisos de contestación:", error);
    }
  }, [enabled]);

  useEffect(() => {
    reload();
    const onChange = () => {
      reload();
    };
    window.addEventListener(CONTESTACION_AVISOS_EVENT, onChange);
    return () => window.removeEventListener(CONTESTACION_AVISOS_EVENT, onChange);
  }, [reload]);

  const actuar = useCallback(async (id, accion) => {
    await postContestacionAviso(id, accion);
  }, []);

  return {
    items,
    count: items.length,
    reload,
    entregar: (id) => actuar(id, "entregar"),
    noEntregar: (id) => actuar(id, "no-entregar"),
  };
}
